module.exports = {"numberOfTickets":"Select how many tickets you want:","addToCart":"Add to cart","checkout":"Checkout","credit":"Credit Ticket Sales To:","legendTitle":"Client Seating Chart Legend","pricing":"Pricing","seat":"ST#","available":"Available","reserved":"Seat Reserved","sold":"Seat Sold","held":"Seat Temporarily Held","handicap":"ADA Handicap Seat","wheelchair":"Wheelchair Space","unavailable":"Seat Unavailable","companion":"Companion","obstructed":"Obstructed View","ticketSelection":"Ticket selection","zoom":"Zoom","selectArtist":"Select an Artist"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/ReservedSeating/locales/fr.json
// module id = 1159
// module chunks = 0